import React, { useState, useEffect } from 'react';
import LeadsBulkDeleteModal from './LeadsBulkDeleteModal'; 

const LeadsBulkActions = ({ 
  selectedLeads, 
  onExport, 
  clearSelectedLeads, 
  loadLeads 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (selectedLeads.length === 0) {
      setBulkAction('');
    }
  }, [selectedLeads]);

  const handleBulkAction = async () => {
    if (!selectedLeads.length) {
      alert('No leads selected.');
      return;
    }

    if (bulkAction === 'delete') {
      setIsBulkDeleteModalOpen(true);
    } else if (bulkAction === 'export') {
      await onExport(selectedLeads);
      clearSelectedLeads();
      setBulkAction('');
    }
  };

  return (
    <div className="bulk-actions-container">
      <select
        className="bulk-actions-select"
        value={bulkAction}
        onChange={(e) => setBulkAction(e.target.value)}
        style={{
          backgroundColor: selectedLeads.length > 0 ? '#f8f8f8' : '#f2f2f2',
          color: selectedLeads.length > 0 ? '#000' : '#999',
        }}
      >
        <option value="">Bulk Actions</option>
        <option value="delete">Delete</option>
        <option value="export">Export to CSV</option>
      </select>
      <button
        className="button secondary"
        onClick={handleBulkAction}
        disabled={!bulkAction || selectedLeads.length === 0}
      >
        Apply
      </button>

      <LeadsBulkDeleteModal
        isOpen={isBulkDeleteModalOpen}
        onClose={() => {
          setIsBulkDeleteModalOpen(false);
          clearSelectedLeads();
        }}
        onSuccess={() => {
          loadLeads();
          setIsBulkDeleteModalOpen(false);
          clearSelectedLeads();
          setBulkAction('');
        }}
        leads={selectedLeads}
      />
    </div>
  );
};

export default LeadsBulkActions;